import { render, staticRenderFns } from "./NotificationsPopover.vue?vue&type=template&id=377e3a7b&scoped=true&"
import script from "./NotificationsPopover.vue?vue&type=script&lang=js&"
export * from "./NotificationsPopover.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsPopover.vue?vue&type=style&index=0&id=377e3a7b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377e3a7b",
  null
  
)

export default component.exports